module.exports = __webpack_public_path__ + "img/logo.9861c036.png";